
import Vue from 'vue'

export default Vue.extend({
	name: 'CompanyCard',
	props: {
		companyName: {
			type: String,
			required: true
		},
		companyNpwp: {
			type: String,
			required: true
		}
	}
})
